const TeachingData = [
 { title: "Deep Learning for Digital Humanities and the Social Sciences",
         description: <p>In <b>DL4DH+SoS </b> students apply Deep Learning knowledge (especially LLMs) to problems from the humanities (including psychology) and the social sciences. Held at UTN (joint with XY).</p>,
         date: "SS2025",
 },
 { title: "Solving Complex Tasks with LLMs",
	 description: <p>In <a href="https://www.uni-mannheim.de/dws/teaching/course-details/courses-for-master-candidates/cs-715-seminar-on-solving-complex-tasks-using-large-language-models/">Solving Complex Tasks with LLMs</a>, students solved tasks with LLMs, such as generating poetry or inducing LLM-based evaluation metrics. Held at University of Mannheim (joint with Chris Bizer).</p>,
	 date: "WS2023, SS2024",
 },
 {
    title: "SNLP",
    description: <p>In <a href="https://ekvv.uni-bielefeld.de/sinfo/publ/modul/39160638">Statistical NLP</a>, we covered the NLP era from 1990 to 2010, with a focus on models such as HMMs, CRFs, and MEMs. Held at Bielefeld University.</p>,
    date: "WS2022",
  },
  {
    title: "ELSI",
    description: <p>In the seminar <a href="https://ekvv.uni-bielefeld.de/sinfo/publ/modul/108247040">ELSI</a>, we discussed Ethical, Legal and Social Aspects of data science. Held at Bielefeld University.</p>,
    date: "WS2022",
  },
  {
    title: "DL4NLP",
    description: <p>In the project seminar (and lecture) Deep Learning for NLP, we covered the NLP era from 2011 onwards, with a focus on deep learning models and representations. Held at Bielefeld University (and previously at TU Darmstadt). Details are on the <a href="https://github.com/steffeneger/dl4nlp">course github</a>.</p>,
    date: "SS2022, SS2016-SS2019",
  },
  {
    title: "DLDH",
    description: <p>In the seminar Deep Learning and Digital Humanities, we covered problems at the intersection of Deep Learning and Digital Humanities. Held at TU Darmstadt. Details are on the <a href="https://github.com/steffeneger/dldh">course github</a>.</p>,
    date: "WS2019-WS2021",
  },
  {
    title: "MSE",
    description: <p>In the seminar Meta Science and Evaluation, we covered problems involving the science of science (e.g., citation count prediction) and evaluation (for text generation models). Held at TU Darmstadt. Details are on the <a href="https://github.com/steffeneger/MetaScience">course github</a>.</p>,
    date: "SS2020-SS2021",
  },
  {
    title: "Foundations of Language Techbology",
    description: <p>In the lecture Foundations of Language Technology, we looked at elementary aspects of NLP such as corpora, tokenization, embeddings, programming (in Python) and foundational tasks such as POS Tagging, Dependency Parsing, etc. Held at TU Darmstadt..</p>,
    date: "WS2019-WS2021",
  },


];

export default TeachingData;
